import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Grid } from "@mui/material";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import AddIcon from "@mui/icons-material/Add";
import _ from "lodash";
import { enqueueSnackbar } from "notistack";

import useAxiosPrivate from "../hooks/useAxiosPrivate";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const { REACT_APP_ACCOUNTS_API_URL } = process.env;
const endpoint = "account-state";

export default function AddAccountType() {
  const [open, setOpen] = React.useState(false);
  const [state, setState] = React.useState("");
  const [description, setDesc] = React.useState("");
  const axios = useAxiosPrivate();

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleChange = (event) => {
    const { value, name } = event.target;
    switch (name) {
      case "state":
        setState(value);
        break;
      case "description":
        setDesc(value);
        break;
      default:
        alert(`Unknown field : ${event.target.name}`);
    }
  };

  const add = (e) => {
    const data = new FormData(e.currentTarget);
    e.preventDefault();

    const state = data.get("state");
    const description = data.get("description");

    if (_.isEmpty(state) || _.isEmpty(description)) {
      return enqueueSnackbar("Please fill all fields", {
        variant: "error",
      });
    }

    setOpen(false);
    axios
      .post(`${REACT_APP_ACCOUNTS_API_URL}/${endpoint}`, {
        description,
        state,
      })
      .then((res) => {
        if (res.status === 200) {
          enqueueSnackbar("Account State added successfully.", {
            variant: "success",
          });
        }
      })
      .catch((err) => {
        return enqueueSnackbar(`${err.response.data.apiErrors[0].cause}`, {
          variant: "error",
        });
      });
  };

  return (
    <React.Fragment>
      <Grid
        item
        xs={12}
        lg={12}
        md={12}
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
        pb={1}
      >
        <Paper>
          <div>
            <Button onClick={handleOpen}>Add New Account State</Button>
            <Modal
              aria-labelledby="addAccountState"
              aria-describedby="add new account state"
              open={open}
              onClose={handleClose}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{
                timeout: 500,
              }}
            >
              <Fade in={open}>
                <Box sx={style}>
                  <Typography
                    id="addAccountState"
                    variant="h6"
                    component="h2"
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    Enter Account State Details
                  </Typography>

                  <Box
                    mt={2}
                    sx={{
                      width: 500,
                      maxWidth: "100%",
                      m: 1,
                    }}
                    component="form"
                    onSubmit={add}
                  >
                    <Grid container direction={"column"} spacing={2}>
                      <Grid item>
                        <TextField
                          required
                          fullWidth
                          label="State"
                          id="state"
                          name="state"
                          onChange={handleChange}
                        />
                      </Grid>

                      <Grid item>
                        <TextField
                          required
                          fullWidth
                          label="Description"
                          id="description"
                          name="description"
                          onChange={handleChange}
                        />
                      </Grid>

                      <Grid
                        item
                        sx={{ display: "flex", justifyContent: "center" }}
                      >
                        <Button
                          variant="outlined"
                          startIcon={<AddIcon />}
                          type="submit"
                          color="primary"
                        >
                          Add New Account State
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
              </Fade>
            </Modal>
          </div>
        </Paper>
      </Grid>
    </React.Fragment>
  );
}
